import React, { useState } from 'react';
import IndefiniteProgressBar from './indefinite_progress_bar';
import { LinkUITealBoldUnderlined } from './common_links';
import { txb } from './text_style_components';

/**
 * explains that we use best in class models
 */
const AI_INTERVIEWER_BOASTING=()=>{
  return (
    <div className="text-sm italic text-center text-gray-600">
      Our AI Interviewer is Powered by 
      <span className='font-bold text-teal-600'> GPT-4.1 </span> 
      - the latest <LinkUITealBoldUnderlined text="upgrade over GPT‑4o" 
      url="https://openai.com/index/gpt-4-1/" />.
      <br />
      It has {txb('smarter reasoning, ')} 
       {txb('faster responses ')} and real-time conversations that feel more human.
     </div>
  );
  /*
  <LinkUITealBoldUnderlined 
        text="Smarter reasoning," 
        url="https://www.hackerrank.com/ai/leaderboard#ASTRAleaderboard" />
   */
}

/**
 * explains that we use best in class models
 */
const AI_INTERVIEWER_BOASTING_GPT_5=()=>{
  return (
    <div className="text-sm italic text-center text-gray-600">
      Our AI Interviewer is Powered by 
      <span className='font-bold text-teal-600'> 
        <LinkUITealBoldUnderlined text="GPT-5" 
      url="https://openai.com/index/introducing-gpt-5/" />
       </span> 
      - the strongest coding model till date from OpenAI.
      <br />
      It has {txb('smarter reasoning, ')} 
       {txb('faster responses ')} and real-time conversations that feel more human.
     </div>
  );

  /*
  <LinkUITealBoldUnderlined 
        text="Smarter reasoning," 
        url="https://www.hackerrank.com/ai/leaderboard#ASTRAleaderboard" />
   */
}


/**
 * shows UI for message, error message and 
 * circular progressbar, all three parameters are state variables
 */
const MSG_ERROR_PROGRESS_UI=(
  {message, error, showProgress})=>{
  return (
   <div className="flex flex-col items-center justify-center
   text-center">
    {showProgress && <IndefiniteProgressBar />}
    {showProgress && (error || message) && <div className="p-1"></div>}
    {error && error.length>0 &&
    <div className="text-lg prose font-bold text-red-700"
    dangerouslySetInnerHTML={{ __html: error }}>
    </div>
    }

    {message && message.length>0 && !error && error.length==0 &&
    <div className="text-xl font-bold text-teal-600"
    dangerouslySetInnerHTML={{ __html: message }}>
    </div>
    }
   </div>
  )
}

/**
 * shows UI for message, error message and 
 * circular progressbar, all three parameters are state variables
 */
const MSG_ERROR_PROGRESS_WITH_TEXT_UI=(
  {message, error, showProgress, progressText})=>{
  return (
   <div className="flex flex-col items-center justify-center
   text-center">

    {showProgress && 
    <IndefiniteProgressBar  />}
    {
      showProgress && progressText &&
      <div className="text-teal-600 text-sm">
        {progressText}</div>

    }
    {error && error.length>0 &&
    <div className="text-lg font-bold text-red-700">
    {error} 
    </div>
    }

    {message && message.length>0 && !error && error.length==0 &&
    <div className="text-xl font-bold text-blue-700">
    {message} 
    </div>
    }
   </div>
  )
}

/**
 * This is a responsive line break <br /> which doesn't show up on mobile
 * screens and only on tablet, desktop and above.
 * use this when you want to use full screen of mobile phone for reading text
 */
const BRR=()=>{
  return (
    <span className="hidden md:block"></span>
  )
}

/**
 * This is a responsive space which doesn't show up on mobile
 * screens and only on tablet, desktop and above.
 */
const SPACE=()=>{
  return (
    <span className="hidden md:inline-block">&nbsp;</span>
  )
}

/**
 * This is 2 responsive spaces which doesn't show up on mobile
 * screens and only on tablet, desktop and above.
 */
const SPACE2=()=>{
  return (
    <span className="hidden md:inline-block">&nbsp;&nbsp;</span>
  )
}


export {BRR, SPACE, SPACE2, 
  MSG_ERROR_PROGRESS_UI, AI_INTERVIEWER_BOASTING,
  AI_INTERVIEWER_BOASTING_GPT_5};